import { useQuery } from '@tanstack/react-query';
import cacheQueryKeys from 'resources/ReactQuery/queryCacheKeys';
import { statusCodesMapper } from 'utils/exception/statusCodesMapper';

import { OnlineBookingErrors } from 'components/OnlineBooking/api/errors';

import { fetchOrgData } from '../api/api';

export const useOrgData = ({ orgUuid }: { orgUuid: string }) => {
  return useQuery([cacheQueryKeys.PublicOrgData], async () => {
    const response = await fetchOrgData(orgUuid);

    return statusCodesMapper(response, {
      [OnlineBookingErrors.orgNotFound]: () => {
        throw new Error(OnlineBookingErrors.orgNotFound);
      },
      unhandled: () => {
        throw new Error();
      },
    });
  });
};
